import type { AccountOptionsResponse } from '@/types/api'

export const DEFAULT_ACCOUNT_OPTIONS: AccountOptionsResponse = {
  account_types: ['ZERO', 'STANDARD', 'PRO'],
  exchange_rates: [10000, 12000, 14000],
  leverage_options: ['1:50', '1:100', '1:200', '1:500'],
  demo_platforms: [
    { id: 'standard', label: 'MetaTrader 5' },
    { id: 'tradingview', label: 'TradingView' },
  ],
  demo_initial_balances: [1000, 5000, 20000],
}

export function getAccountTypeLabel(type: string): string {
  return type.replace(/_/g, ' ')
}

export const ANNUAL_INCOME_OPTIONS = [
  '100_250_JUTA',
  '250_500_JUTA',
  'DIATAS_500_JUTA',
] as const

export type AnnualIncomeOption = (typeof ANNUAL_INCOME_OPTIONS)[number]
